import { NavItem } from '@/ui-components/organisms/NavHeader/NavHeader.type';

export function mapSiteLinkToNavItem(link: SiteLink): NavItem {
    const { fields } = link;

    return {
        title: fields.link_text,
        link: fields.href,
        aria_label: fields.aria_label,
        link_type: fields.link_type,
        link_target: fields.link_target,
        authenticatedItem: fields.authenticated_link ? mapSiteLinkToNavItem(fields.authenticated_link) : undefined,
    };
}

export function resolveDesktopNavCtas(
    navItems: NavItem[] | undefined,
    isAuthenticated: boolean,
): NavItem[] | undefined {
    return navItems?.map((item) => (isAuthenticated && item.authenticatedItem ? item.authenticatedItem : item));
}

export function createNavigationCtaCollections(navItems: NavItem[] | undefined, isAuthenticated: boolean) {
    return {
        desktopNavRightCtas: resolveDesktopNavCtas(navItems, isAuthenticated),
        mobileNavRightCtas: navItems,
    };
}
